module.exports = __webpack_public_path__ + "img/gate-rail-vertical-right.0c5ed99c.png";